import { useState, useEffect } from 'react';
import { api } from '../api';

const BODEGAS = [
  { cod: 1, nombre: 'BOD. 1',         color: '#4cc9f0' },
  { cod: 4, nombre: 'BOD. LA MANA',   color: '#ffc107' },
  { cod: 5, nombre: 'BOD. SAN CAMILO',color: '#e63946' },
  { cod: 6, nombre: 'BOD. BAJANA',    color: '#4caf50' },
];

const FILTROS_CRUCE = [
  { key: 'todos',         label: 'Todos'           },
  { key: 'cruzado',       label: '🔀 Cruzado'       },
  { key: 'solo_negativo', label: '🔴 Solo negativo' },
  { key: 'solo_positivo', label: '🟢 Solo positivo' },
];

const TIPO_STYLE = {
  cruzado:       { bg: '#1a2a3e', color: '#4cc9f0', label: '🔀 Cruzado'  },
  solo_negativo: { bg: '#3a1a1a', color: '#e63946', label: '🔴 Negativo' },
  solo_positivo: { bg: '#1a3a2a', color: '#4caf50', label: '🟢 Positivo' },
};

const fmt  = (n) => (n || 0).toLocaleString('es-EC', { minimumFractionDigits: 2 });
const fmtN = (n) => {
  const v = n || 0;
  return (v < 0 ? '-' : '') + '$' + Math.abs(v).toLocaleString('es-EC', { minimumFractionDigits: 2 });
};

export default function AuditoriaBodegas() {
  const [tab, setTab]           = useState('resumen');
  const [resumen, setResumen]   = useState(null);
  const [cruce, setCruce]       = useState(null);
  const [detalle, setDetalle]   = useState(null);  // { cod, data }
  const [cargando, setCargando] = useState(false);
  const [filtroCruce, setFiltroCruce] = useState('todos');
  const [filtroDetalle, setFiltroDetalle] = useState('todos');
  const [bodegaActiva, setBodegaActiva]   = useState(null);
  const [busqCruce, setBusqCruce]         = useState('');
  const [busqDetalle, setBusqDetalle]     = useState('');

  useEffect(() => { cargarResumen(); }, []);
  useEffect(() => {
    if (tab === 'cruce' && !cruce) cargarCruce('todos');
  }, [tab]);

  const cargarResumen = async () => {
    setCargando(true);
    try {
      const data = await api.get('/bodegas/resumen');
      setResumen(data.error ? null : data);
    } catch(e) { console.error(e); }
    finally { setCargando(false); }
  };

  const cargarCruce = async (filtro) => {
    setCargando(true);
    setFiltroCruce(filtro);
    try {
      const data = await api.get(`/bodegas/cruce?filtro=${filtro}`);
      setCruce(data.error ? null : data);
    } catch(e) { console.error(e); }
    finally { setCargando(false); }
  };

  const cargarDetalle = async (cod, filtro = 'todos') => {
    setCargando(true);
    setBodegaActiva(cod);
    setFiltroDetalle(filtro);
    try {
      const data = await api.get(`/bodegas/detalle/${cod}?filtro=${filtro}`);
      setDetalle(data.error ? null : { cod, data });
    } catch(e) { console.error(e); }
    finally { setCargando(false); }
  };

  const itemsCruceFiltrados = (cruce?.items || []).filter(i =>
    !busqCruce ||
    i.item.toUpperCase().includes(busqCruce.toUpperCase()) ||
    i.codigo_bar.includes(busqCruce) ||
    i.marca.toUpperCase().includes(busqCruce.toUpperCase())
  );

  const itemsDetalleFiltrados = (detalle?.data?.items || []).filter(i =>
    !busqDetalle ||
    i.item.toUpperCase().includes(busqDetalle.toUpperCase()) ||
    i.codigo_bar.includes(busqDetalle) ||
    i.marca.toUpperCase().includes(busqDetalle.toUpperCase())
  );

  return (
    <div>
      {/* Header */}
      <div style={s.headerRow}>
        <div>
          <h2 style={s.titulo}>🏭 Auditoría de Bodegas</h2>
          <p style={s.subtitulo}>
            Análisis forense de stock en bodegas secundarias · BOD. ESTACION no incluida
          </p>
        </div>
        <button style={s.btnRefresh} onClick={() => {
          setResumen(null); setCruce(null); setDetalle(null);
          cargarResumen();
          if (tab === 'cruce') cargarCruce(filtroCruce);
          if (tab === 'detalle' && bodegaActiva) cargarDetalle(bodegaActiva, filtroDetalle);
        }}>🔄 Actualizar</button>
      </div>

      {/* Tabs */}
      <div style={{ display: 'flex', gap: 8, marginBottom: 24 }}>
        {[
          { key: 'resumen', label: '📊 Resumen'         },
          { key: 'cruce',   label: '🔀 Cruce de Stock'  },
          { key: 'detalle', label: '🔍 Por Bodega'      },
        ].map(t => (
          <button key={t.key}
            style={{
              padding: '8px 20px', borderRadius: 8, cursor: 'pointer',
              fontSize: 13, fontWeight: 'bold',
              background: tab === t.key ? '#1a2a3e' : 'none',
              border: tab === t.key ? '1px solid #4cc9f0' : '1px solid #2d2d44',
              color: tab === t.key ? '#4cc9f0' : '#888',
            }}
            onClick={() => setTab(t.key)}>
            {t.label}
          </button>
        ))}
      </div>

      {cargando && <p style={s.cargando}>Cargando...</p>}

      {/* ══ TAB RESUMEN ══ */}
      {!cargando && tab === 'resumen' && resumen && (
        <>
          {/* KPIs globales */}
          <div style={s.kpisRow}>
            <div style={{ ...s.kpiCard, borderTopColor: '#e63946' }}>
              <div style={{ ...s.kpiValor, color: '#e63946' }}>
                {fmtN(resumen.total_negativo)}
              </div>
              <div style={s.kpiLabel}>Valor en negativo</div>
            </div>
            <div style={{ ...s.kpiCard, borderTopColor: '#4caf50' }}>
              <div style={{ ...s.kpiValor, color: '#4caf50' }}>
                ${fmt(resumen.total_positivo)}
              </div>
              <div style={s.kpiLabel}>Valor en positivo</div>
            </div>
            <div style={{ ...s.kpiCard, borderTopColor: '#ffc107' }}>
              <div style={{ ...s.kpiValor, color: '#ffc107' }}>
                {resumen.total_items_anomalos}
              </div>
              <div style={s.kpiLabel}>Items con stock negativo</div>
            </div>
            <div style={{ ...s.kpiCard, borderTopColor: '#7209b7' }}>
              <div style={{ ...s.kpiValor, color: '#fff' }}>
                {fmtN(resumen.total_negativo + resumen.total_positivo)}
              </div>
              <div style={s.kpiLabel}>Valor neto bodegas secundarias</div>
            </div>
          </div>

          {/* Cards por bodega */}
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
            {resumen.bodegas.map(b => (
              <div key={b.codigo} style={{ ...s.card, borderLeft: `4px solid ${b.color}` }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 16 }}>
                  <div>
                    <div style={{ color: b.color, fontWeight: 'bold', fontSize: 15 }}>{b.nombre}</div>
                    <div style={{ color: '#555', fontSize: 11, marginTop: 2 }}>
                      {b.total_items} items registrados
                    </div>
                  </div>
                  <div style={{ display: 'flex', gap: 6 }}>
                    <button
                      style={{ ...s.btnSmall, borderColor: '#e63946', color: '#e63946' }}
                      onClick={() => { setTab('detalle'); cargarDetalle(b.codigo, 'negativos'); }}>
                      Ver negativos
                    </button>
                    <button
                      style={{ ...s.btnSmall, borderColor: b.color, color: b.color }}
                      onClick={() => { setTab('detalle'); cargarDetalle(b.codigo, 'todos'); }}>
                      Ver todos
                    </button>
                  </div>
                </div>

                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 10 }}>
                  {[
                    ['Negativos',  b.items_negativos, '#e63946'],
                    ['Positivos',  b.items_positivos, '#4caf50'],
                    ['En cero',    b.items_cero,      '#555'   ],
                  ].map(([label, val, color]) => (
                    <div key={label} style={{ background: '#0f0f1a', borderRadius: 8, padding: '10px 12px' }}>
                      <div style={{ color, fontSize: 20, fontWeight: 'bold' }}>{val}</div>
                      <div style={{ color: '#555', fontSize: 11 }}>{label}</div>
                    </div>
                  ))}
                </div>

                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10, marginTop: 10 }}>
                  <div style={{ background: '#0f0f1a', borderRadius: 8, padding: '10px 12px' }}>
                    <div style={{ color: '#e63946', fontSize: 14, fontWeight: 'bold' }}>
                      {fmtN(b.valor_negativo)}
                    </div>
                    <div style={{ color: '#555', fontSize: 11 }}>Valor negativo</div>
                  </div>
                  <div style={{ background: '#0f0f1a', borderRadius: 8, padding: '10px 12px' }}>
                    <div style={{ color: '#4caf50', fontSize: 14, fontWeight: 'bold' }}>
                      ${fmt(b.valor_positivo)}
                    </div>
                    <div style={{ color: '#555', fontSize: 11 }}>Valor positivo</div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </>
      )}

      {/* ══ TAB CRUCE DE STOCK ══ */}
      {!cargando && tab === 'cruce' && cruce && (
        <>
          {/* KPIs tipos */}
          <div style={s.kpisRow}>
            {[
              { key: 'cruzado',       label: '🔀 Cruzados',       color: '#4cc9f0' },
              { key: 'solo_negativo', label: '🔴 Solo negativos',  color: '#e63946' },
              { key: 'solo_positivo', label: '🟢 Solo positivos',  color: '#4caf50' },
            ].map(k => (
              <div key={k.key}
                style={{ ...s.kpiCard, borderTopColor: k.color, cursor: 'pointer' }}
                onClick={() => cargarCruce(k.key)}>
                <div style={{ ...s.kpiValor, color: k.color, fontSize: 24 }}>
                  {cruce.totales[k.key]}
                </div>
                <div style={s.kpiLabel}>{k.label}</div>
              </div>
            ))}
            <div style={{ ...s.kpiCard, borderTopColor: '#e63946' }}>
              <div style={{ ...s.kpiValor, color: '#e63946', fontSize: 22 }}>
                {fmtN(cruce.totales.valor_en_riesgo)}
              </div>
              <div style={s.kpiLabel}>Valor en riesgo</div>
            </div>
          </div>

          {/* Filtros */}
          <div style={{ display: 'flex', gap: 8, marginBottom: 12, alignItems: 'center', flexWrap: 'wrap' }}>
            {FILTROS_CRUCE.map(f => (
              <button key={f.key}
                style={{
                  ...s.filtroBtn,
                  ...(filtroCruce === f.key ? { borderColor: '#4cc9f0', color: '#4cc9f0', background: '#1a2a3e' } : {})
                }}
                onClick={() => cargarCruce(f.key)}>
                {f.label}
              </button>
            ))}
            <input
              style={s.inputBusq}
              placeholder="Buscar producto, código o marca..."
              value={busqCruce}
              onChange={e => setBusqCruce(e.target.value)}
            />
          </div>

          {/* Tabla cruce */}
          <div style={s.tabla}>
            <div style={s.tablaHeader}>
              <span style={{ flex: 3 }}>PRODUCTO</span>
              <span style={{ width: 80,  textAlign: 'right' }}>BOD.1</span>
              <span style={{ width: 90,  textAlign: 'right' }}>LA MANA</span>
              <span style={{ width: 100, textAlign: 'right' }}>SAN CAMILO</span>
              <span style={{ width: 80,  textAlign: 'right' }}>BAJANA</span>
              <span style={{ width: 80,  textAlign: 'right' }}>TOTAL</span>
              <span style={{ width: 100, textAlign: 'right' }}>VALOR</span>
              <span style={{ width: 100, textAlign: 'center' }}>TIPO</span>
            </div>
            <div style={{ maxHeight: 'calc(100vh - 400px)', overflowY: 'auto' }}>
              {itemsCruceFiltrados.length === 0 ? (
                <p style={{ color: '#555', textAlign: 'center', padding: 32 }}>Sin resultados</p>
              ) : itemsCruceFiltrados.map((item, i) => {
                const ts = TIPO_STYLE[item.tipo] || TIPO_STYLE.solo_negativo;
                return (
                  <div key={item.codigo_bar + i} style={{
                    ...s.tablaRow,
                    background: i % 2 === 0 ? '#1e1e2e' : '#1a1a2e',
                    borderLeft: `3px solid ${ts.color}`,
                  }}
                    onMouseEnter={e => e.currentTarget.style.background = '#2d2d44'}
                    onMouseLeave={e => e.currentTarget.style.background = i % 2 === 0 ? '#1e1e2e' : '#1a1a2e'}>

                    <span style={{ flex: 3 }}>
                      <div style={{ color: '#fff', fontSize: 12, fontWeight: '600' }}>{item.item}</div>
                      <div style={{ color: '#555', fontSize: 10 }}>{item.codigo_bar} · {item.marca}</div>
                    </span>

                    {[item.bod1, item.bod_lamana, item.bod_sancamilo, item.bod_bajana].map((val, j) => (
                      <span key={j} style={{
                        width: j === 0 ? 80 : j === 1 ? 90 : j === 2 ? 100 : 80,
                        textAlign: 'right',
                        color: val < 0 ? '#e63946' : val > 0 ? '#4caf50' : '#333',
                        fontSize: 13, fontWeight: val !== 0 ? 'bold' : 'normal',
                      }}>
                        {val !== 0 ? (val > 0 ? '+' : '') + val.toFixed(0) : '—'}
                      </span>
                    ))}

                    <span style={{
                      width: 80, textAlign: 'right', fontSize: 13, fontWeight: 'bold',
                      color: item.total < 0 ? '#e63946' : item.total > 0 ? '#4caf50' : '#555',
                    }}>
                      {item.total > 0 ? '+' : ''}{item.total.toFixed(0)}
                    </span>

                    <span style={{
                      width: 100, textAlign: 'right', fontSize: 12,
                      color: item.valor_total < 0 ? '#e63946' : '#4caf50',
                    }}>
                      {fmtN(item.valor_total)}
                    </span>

                    <span style={{ width: 100, textAlign: 'center' }}>
                      <span style={{
                        background: ts.bg, color: ts.color,
                        borderRadius: 6, padding: '2px 8px', fontSize: 10, fontWeight: 'bold',
                      }}>
                        {ts.label}
                      </span>
                    </span>
                  </div>
                );
              })}
            </div>
          </div>
          <div style={{ color: '#555', fontSize: 12, marginTop: 8, textAlign: 'right' }}>
            {itemsCruceFiltrados.length} items · haz clic en los KPIs para filtrar
          </div>
        </>
      )}

      {/* ══ TAB POR BODEGA ══ */}
      {!cargando && tab === 'detalle' && (
        <>
          {/* Selector de bodega */}
          <div style={{ display: 'flex', gap: 10, marginBottom: 20, flexWrap: 'wrap' }}>
            {BODEGAS.map(b => (
              <button key={b.cod}
                style={{
                  padding: '10px 20px', borderRadius: 8, cursor: 'pointer',
                  fontSize: 13, fontWeight: 'bold',
                  background: bodegaActiva === b.cod ? '#1a1a2e' : 'none',
                  border: `1px solid ${bodegaActiva === b.cod ? b.color : '#2d2d44'}`,
                  color: bodegaActiva === b.cod ? b.color : '#888',
                }}
                onClick={() => cargarDetalle(b.cod, filtroDetalle)}>
                {b.nombre}
              </button>
            ))}
          </div>

          {!detalle && !cargando && (
            <p style={{ color: '#555', textAlign: 'center', padding: 40 }}>
              Selecciona una bodega para ver el detalle
            </p>
          )}

          {detalle && (
            <>
              {/* Header bodega */}
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
                <div>
                  <div style={{ color: BODEGAS.find(b => b.cod === detalle.cod)?.color, fontWeight: 'bold', fontSize: 16 }}>
                    {detalle.data.nombre}
                  </div>
                  <div style={{ color: '#555', fontSize: 12 }}>
                    {detalle.data.total} items · Valor total:{' '}
                    <span style={{ color: detalle.data.valor_total < 0 ? '#e63946' : '#4caf50', fontWeight: 'bold' }}>
                      {fmtN(detalle.data.valor_total)}
                    </span>
                  </div>
                </div>
                <div style={{ display: 'flex', gap: 6 }}>
                  {[
                    { key: 'todos',     label: 'Todos'    },
                    { key: 'negativos', label: '🔴 Negativos' },
                    { key: 'positivos', label: '🟢 Positivos' },
                  ].map(f => (
                    <button key={f.key}
                      style={{
                        ...s.filtroBtn,
                        ...(filtroDetalle === f.key ? { borderColor: '#4cc9f0', color: '#4cc9f0', background: '#1a2a3e' } : {})
                      }}
                      onClick={() => cargarDetalle(detalle.cod, f.key)}>
                      {f.label}
                    </button>
                  ))}
                </div>
              </div>

              <input
                style={{ ...s.inputBusq, marginBottom: 12 }}
                placeholder="Buscar producto, código o marca..."
                value={busqDetalle}
                onChange={e => setBusqDetalle(e.target.value)}
              />

              {/* Tabla detalle */}
              <div style={s.tabla}>
                <div style={s.tablaHeader}>
                  <span style={{ flex: 4 }}>PRODUCTO</span>
                  <span style={{ width: 100, textAlign: 'right' }}>STOCK</span>
                  <span style={{ width: 100, textAlign: 'right' }}>COSTO U.</span>
                  <span style={{ width: 120, textAlign: 'right' }}>VALOR</span>
                </div>
                <div style={{ maxHeight: 'calc(100vh - 380px)', overflowY: 'auto' }}>
                  {itemsDetalleFiltrados.length === 0 ? (
                    <p style={{ color: '#555', textAlign: 'center', padding: 32 }}>Sin resultados</p>
                  ) : itemsDetalleFiltrados.map((item, i) => (
                    <div key={item.codigo_bar + i} style={{
                      ...s.tablaRow,
                      background: i % 2 === 0 ? '#1e1e2e' : '#1a1a2e',
                      borderLeft: `3px solid ${item.stock < 0 ? '#e63946' : '#4caf50'}`,
                    }}
                      onMouseEnter={e => e.currentTarget.style.background = '#2d2d44'}
                      onMouseLeave={e => e.currentTarget.style.background = i % 2 === 0 ? '#1e1e2e' : '#1a1a2e'}>
                      <span style={{ flex: 4 }}>
                        <div style={{ color: '#fff', fontSize: 13, fontWeight: '600' }}>{item.item}</div>
                        <div style={{ color: '#555', fontSize: 11 }}>{item.codigo_bar} · {item.marca}</div>
                      </span>
                      <span style={{
                        width: 100, textAlign: 'right', fontWeight: 'bold', fontSize: 14,
                        color: item.stock < 0 ? '#e63946' : '#4caf50',
                      }}>
                        {item.stock > 0 ? '+' : ''}{item.stock.toFixed(0)}
                      </span>
                      <span style={{ width: 100, textAlign: 'right', color: '#aaa', fontSize: 12 }}>
                        ${item.costo.toFixed(2)}
                      </span>
                      <span style={{
                        width: 120, textAlign: 'right', fontWeight: 'bold', fontSize: 13,
                        color: item.valor < 0 ? '#e63946' : '#4caf50',
                      }}>
                        {fmtN(item.valor)}
                      </span>
                    </div>
                  ))}
                </div>
              </div>

              {/* Total filtrado */}
              <div style={{ display: 'flex', justifyContent: 'flex-end', padding: '12px 16px', borderTop: '1px solid #2d2d44', marginTop: 4 }}>
                <span style={{ color: '#aaa', fontSize: 13 }}>
                  {itemsDetalleFiltrados.length} items · Total:{' '}
                  <strong style={{
                    color: itemsDetalleFiltrados.reduce((a, i) => a + i.valor, 0) < 0 ? '#e63946' : '#4caf50'
                  }}>
                    {fmtN(itemsDetalleFiltrados.reduce((a, i) => a + i.valor, 0))}
                  </strong>
                </span>
              </div>
            </>
          )}
        </>
      )}
    </div>
  );
}

const s = {
  headerRow:   { display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 24 },
  titulo:      { color: '#fff', marginBottom: 4 },
  subtitulo:   { color: '#555', fontSize: 13 },
  btnRefresh:  { background: 'none', border: '1px solid #444', borderRadius: 8, color: '#aaa', padding: '8px 16px', cursor: 'pointer', fontSize: 13 },
  cargando:    { color: '#aaa', padding: 40, textAlign: 'center' },
  kpisRow:     { display: 'flex', gap: 12, marginBottom: 24, flexWrap: 'wrap' },
  kpiCard:     { background: '#1e1e2e', borderRadius: 12, padding: '16px 20px', flex: 1, minWidth: 140, borderTop: '3px solid #7209b7' },
  kpiValor:    { fontSize: 22, fontWeight: 'bold', color: '#fff', marginBottom: 4 },
  kpiLabel:    { color: '#aaa', fontSize: 11 },
  card:        { background: '#1e1e2e', borderRadius: 12, padding: 20 },
  btnSmall:    { background: 'none', border: '1px solid', borderRadius: 6, padding: '4px 12px', cursor: 'pointer', fontSize: 11, fontWeight: 'bold' },
  filtroBtn:   { background: '#1e1e2e', border: '1px solid #2d2d44', borderRadius: 6, color: '#888', padding: '6px 14px', cursor: 'pointer', fontSize: 12 },
  inputBusq:   { flex: 1, minWidth: 240, background: '#0f0f1a', border: '1px solid #2d2d44', borderRadius: 8, color: '#fff', padding: '8px 14px', fontSize: 13 },
  tabla:       { background: '#1e1e2e', borderRadius: 12, overflow: 'hidden' },
  tablaHeader: { display: 'flex', padding: '10px 16px', background: '#0f0f1a', color: '#555', fontSize: 11, fontWeight: 'bold', gap: 8 },
  tablaRow:    { display: 'flex', padding: '10px 16px', gap: 8, alignItems: 'center', borderBottom: '1px solid #0f0f1a', transition: 'background 0.15s' },
};
